import { BrowserRouter, Routes, Route } from "react-router-dom";
// import PrivateRoute from "./utils/PrivateRoute";
import Login from "./components/Login";
import Register from "./components/Register";
import Welcome from "./components/Welcome";
import Dashboard from "./components/Dashboard";
import Billing from "./components/Billing";
import ProtectedRoute from "./components/ProtectedRoute";
import StockManagement from "./components/StockManagement";
import LandingPage from "./components/LandingPage";

import ProductDetails from "./components/ProductDetails";

import VehicleStock from "./components/VehicleStock";

import Dues from "./components/Dues";

import AllHistory from "./components/AllHistory";




// import Billing from "./components/Billing";

function App() {
  return (
    <BrowserRouter>
    <Routes>
  <Route path="/" element={<Welcome />} />
  <Route path="/login" element={<Login />} />
  <Route path="/register" element={<Register />} />

    {/* 🔐 PROTECTED DASHBOARD */}
    <Route  path="/dashboard" element={
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      }  />

      <Route path="/stock-management"  element={
            <ProtectedRoute>
              <StockManagement />
            </ProtectedRoute>
          }  />

      <Route path="/create-bill"  element={
            <ProtectedRoute>
              <Billing />
            </ProtectedRoute>
          }  />

          <Route path="/dues" element={
            <ProtectedRoute>
             <Dues/>
            </ProtectedRoute>
            } />

            <Route path="/LandingPage" element={
              <ProtectedRoute>
              <LandingPage/>
              </ProtectedRoute>
           } />

           <Route path="/product/:id" element={
            <ProtectedRoute>
               <ProductDetails />
              </ProtectedRoute>
            } />

            <Route path="/vehicle-stock" element={
              <ProtectedRoute>
                <VehicleStock />
              </ProtectedRoute>
              
              } />

              <Route path="/all-history" element={
              <ProtectedRoute>
                <AllHistory />
              </ProtectedRoute>

                } />

</Routes>
    </BrowserRouter>
  );
}

export default App;
